import { atom } from 'recoil';
import type { RecoilState } from 'recoil';
import {
  localForagePersisterEffect,
  broadcastChannelSynchronizerEffect,
} from 'utils/recoilEffects';
import type { Layout } from 'config/constants';
import { MAX_VIEWER_WINDOWS } from 'config/constants';

/*
 * Layout is structured as [<# of rows>, <# of columns>] tuple
 */
export type { Layout };

export type Layouts = {
  [windowId: string]: Layout;
};

export type AllLayouts = {
  [caseSmid: string]: Layouts;
};

export const DEFAULT_LAYOUT: Layout = [2, 2];
export const DEFAULT_LAYOUTS: Layouts = Object.fromEntries(
  Array.from({ length: MAX_VIEWER_WINDOWS }, (_, i) => [String(i), DEFAULT_LAYOUT])
);

const MAX_PERSISTED_CASE_LAYOUTS = 250;

// Reinsert an updated case so string-key iteration order represents update recency.
export function updateCaseLayouts(
  allLayouts: AllLayouts,
  caseSmid: string,
  layouts: Layouts
): AllLayouts {
  const updatedLayouts = { ...allLayouts };
  delete updatedLayouts[caseSmid];
  updatedLayouts[caseSmid] = layouts;
  return updatedLayouts;
}

export function retainMostRecentCaseLayouts(layouts: AllLayouts): AllLayouts {
  return Object.fromEntries(Object.entries(layouts).slice(-MAX_PERSISTED_CASE_LAYOUTS));
}

export const layoutsForAllCasesState: RecoilState<AllLayouts> = atom({
  key: 'layoutsForAllCasesState',
  default: {},
  effects: [
    broadcastChannelSynchronizerEffect(),
    localForagePersisterEffect({
      version: 3,
      transformBeforeSave: retainMostRecentCaseLayouts,
    }),
  ],
});
